module.exports = __webpack_public_path__ + "static/assets/8715c5ba8f9748ecab5a3117650d1dbb.svg";